import React, { useMemo } from "react";
import WidenBaseVideoPlayer from "components/Video/WidenBaseVideoPlayer";
import { useIsTabletOrDesktop } from "src/utils/useIsTabletOrDesktop";

type Props = {
  className?: string;
  trackingTitle?: string;
  videoId: string;
  mobileVideoId?: string;
};

const BackgroundVideo: React.FC<Props> = ({
  videoId,
  mobileVideoId,
  trackingTitle,
  className
}) => {
  const isTabletOrDesktop = useIsTabletOrDesktop();
  const actialVideoId = useMemo(() => {
    const responsiveVideoId = isTabletOrDesktop ? videoId : mobileVideoId;
    return responsiveVideoId || videoId;
  }, [isTabletOrDesktop, mobileVideoId, videoId]);

  return (
    <WidenBaseVideoPlayer
      className={className}
      trackingTitle={trackingTitle || "background-video"}
      videoId={actialVideoId}
      autoPlay
      loop
      muted
      playsinline
      controls={false}
      width="100%"
      height="100%"
      playing
      aria-label="Background video"
      config={{
        autoPlay: true,
        muted: true
      }}
    />
  );
};

export default BackgroundVideo;
